var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailPickup(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.577 31.87a4.33 4.33 0 0 1-.654 2.3 4.37 4.37 0 0 1-1.778 1.608l-.08.036-6.944 2.939q-.103.045-.213.071l-11.446 2.843a1.4 1.4 0 0 1-.347.045h-18.6c-.759 0-1.486-.3-2.023-.833a2.83 2.83 0 0 1-.838-2.01V31.76c0-.754.301-1.477.838-2.01a2.87 2.87 0 0 1 2.023-.833h5.131l4.046-4.021a5.7 5.7 0 0 1 4.047-1.665h8.953c.756 0 1.502.17 2.182.496.68.327 1.277.803 1.746 1.392a4.96 4.96 0 0 1 .946 4.233l7.483-1.71a4.43 4.43 0 0 1 3.81.762c.534.408.967.933 1.265 1.534.298.6.453 1.26.453 1.93m-2.862 0a1.52 1.52 0 0 0-.605-1.215 1.54 1.54 0 0 0-1.339-.26l-.055.014-11.983 2.738a1.5 1.5 0 0 1-.32.035h-5.728c-.38 0-.744-.15-1.012-.416a1.417 1.417 0 0 1 0-2.01 1.44 1.44 0 0 1 1.012-.417h5.007c.57 0 1.115-.224 1.518-.624a2.125 2.125 0 0 0 0-3.016 2.15 2.15 0 0 0-1.518-.624H18.74a2.85 2.85 0 0 0-2.023.833l-4.047 4.02v7.94h11.267l11.166-2.773 6.796-2.875a1.53 1.53 0 0 0 .817-1.35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m42.498 18.567-.002-.006z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m42.42 14.6-1.88 1.867 1.88 1.868q.066.066.117.138c.288.407.25.972-.117 1.335a1.053 1.053 0 0 1-1.482 0l-1.88-1.868-1.88 1.868a1.053 1.053 0 0 1-1.483 0 1.037 1.037 0 0 1 0-1.473l1.88-1.868-1.88-1.868a1.037 1.037 0 0 1 0-1.473 1.053 1.053 0 0 1 1.483 0l1.88 1.868 1.88-1.868a1.05 1.05 0 0 1 .872-.296 1.05 1.05 0 0 1 .756.477 1.04 1.04 0 0 1-.146 1.292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33.88 22.386a2.27 2.27 0 0 0 1.13.3q.158 0 .298-.011a.64.64 0 0 0-.025-.66 3.288 3.288 0 0 1-1.084-.72 3.274 3.274 0 0 1 0-4.65l.178-.178-.178-.177a3.273 3.273 0 0 1 0-4.65 3.324 3.324 0 0 1 4.68 0l.178.177.179-.178.123-.116a3.3 3.3 0 0 1 2.249-.846c.292.003.584.044.868.123a2.25 2.25 0 0 0-1.043-1.322L36.14 6.473a2.28 2.28 0 0 0-2.26 0l-5.293 3.005a2.242 2.242 0 0 0-1.133 1.948v6.007c0 .395.105.783.304 1.125.2.342.485.626.83.823z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailPickup);
export default __webpack_public_path__ + "static/media/fail-pickup.22accb88d83595d2903080aca9dff2cf.svg";
export { ForwardRef as ReactComponent };